var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueprintIcon = function SvgBlueprintIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.5,
    fill: "#E6F1F2",
    fillOpacity: 0.05,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.098 28.402a3.75 3.75 0 0 0 5.304 0L23.803 22m-9.053 7.5A3.75 3.75 0 0 1 11 25.75V12.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v4.072M14.75 29.5a3.75 3.75 0 0 0 3.75-3.75v-9.053M14.75 29.5h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M18.5 16.697l2.88-2.88c.439-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.151 0 1.59L23.803 22m-9.053 3.75h.008v.008h-.008z"
  })));
};
export { SvgBlueprintIcon as ReactComponent };
export default __webpack_public_path__ + "f1947840fac3d6622a17350c9ade5f93.svg";